<form novalidate #currentForm="ngForm">
  <div class="form-group" *ngIf="!toBePaid.id">
    <div class="custom-control custom-control-inline custom-radio" (click)="formOption = 'charge'">
      <input type="radio" [checked]="formOption == 'charge'" name="form-option" class="custom-control-input" />
      <label class="custom-control-label">Create Charge</label>
    </div>
    &nbsp;&nbsp;
    <div class="custom-control custom-control-inline custom-radio" (click)="formOption = 'payment'">
      <input type="radio" [checked]="formOption == 'payment'" name="form-option" class="custom-control-input" />
      <label class="custom-control-label">Create Payment</label>
    </div>
  </div>
  <div *ngIf="formOption == 'charge' || formOption == 'payment'">
    <div class="form-group row">
      <label class="col-sm-2 col-form-label">Matter</label>
      <div class="col-sm-10">
        <app-matter-search [matterId]="toBePaid.matter_id" [include_item]="true" (matter)="onMatterSelect($event)"></app-matter-search>
        <div *ngIf="matter">
          Selected Matter: <a [href]="'/matters/' + matter.id" target="_blank">{{ matter.label }}</a>
        </div>
        <div *ngIf="!matter && formSubmitted" class="text-danger">Please select a matter</div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 col-form-label">Vendor</label>
      <div class="col-sm-10">
        <select required class="form-control" *ngIf="matter" name="vendor_id" [(ngModel)]="vendor" (change)="onVendorSelect()">
          <option *ngFor="let vendorItem of vendors" [ngValue]="vendorItem">{{ vendorItem.label }}</option>
        </select>
        <div *ngIf="matter && !vendor && formSubmitted" class="text-danger">Vendor needs to be selected</div>
        <label class="col-sm-10 col-form-label text-warning" *ngIf="!matter">Select a matter to list vendors</label>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 col-form-label">Amount</label>
      <div class="col-sm-10">
        <div class="input-group">
          <div class="input-group-prepend"><div class="input-group-text">$</div></div>
          <input type="number" class="form-control" name="amount" [(ngModel)]="toBePaid.amount" />
        </div>
        <div *ngIf="!toBePaid.amount && formSubmitted" class="text-danger">Amount needs to be entered</div>
        <div *ngIf="toBePaid.amount && formSubmitted && !validationFunctionsService.numberValidation(toBePaid.amount)" class="text-danger">Amount is to be a number</div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 col-form-label">Chart of Account</label>
      <div class="col-sm-10">
        <select required class="form-control" name="chart_of_account_id" [(ngModel)]="toBePaid.chart_of_account_id" #chart_of_account_id="ngModel">
          <option *ngFor="let chart_of_account of formOptions.chart_of_accounts" [value]="chart_of_account.value">{{ chart_of_account.label }}</option>
        </select>
        <div *ngIf="!toBePaid.chart_of_account_id && formSubmitted" class="text-danger">Chart of account needs to be selected</div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 col-form-label">Status</label>
      <div class="col-sm-10">
        <div style="cursor: pointer; min-width: 140px" *ngFor="let status of formOptions.statuses" class="custom-control custom-radio text-dark" (click)="toBePaid.status = status.value">
          <input type="radio" [checked]="toBePaid.status == status.value" name="status" class="custom-control-input" />
          <label style="min-width: 100px" [class]="'custom-control-label badge badge-' + status.bg_color">{{ status.label }}</label>
        </div>
        <br />
        <div *ngIf="!toBePaid.status && formSubmitted" class="text-danger">Status needs to be selected</div>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-sm-2 col-form-label">Description</label>
      <div class="col-sm-10">
        <textarea class="form-control" name="description" [(ngModel)]="toBePaid.description"> </textarea>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-10 ml-auto">
        <div class="custom-control custom-checkbox" (click)="toBePaid.is_priority = !toBePaid.is_priority">
          <input name="is_priority" type="checkbox" class="custom-control-input" [(ngModel)]="toBePaid.is_priority" [checked]="toBePaid.is_priority" />
          <label class="custom-control-label">High Priority</label>
        </div>
      </div>
    </div>
  </div>
  <div class="form-group text-center">
    <br />
    <button type="button" (click)="saveToBePaid()" class="btn btn-primary" [disabled]="submitDisabled()">{{ toBePaid.id ? 'Update' : formOption == 'check' ? 'Create check' : 'Create' }} <i class="fas fa-spinner fa-pulse fa-fw" *ngIf="formSubmitting || checkSubmitting"></i></button>
    &nbsp;
    <button type="button" (click)="saveAndNewToBePaid()" class="btn btn-primary" *ngIf="!toBePaid.id && formOption != 'check'" [disabled]="submitDisabled()">Create and add another <i *ngIf="formSubmitting" class="fas fa-spinner fa-pulse fa-fw"></i></button>
    &nbsp;
    <button type="button" class="btn btn-outline-secondary" (click)="goBack()" [disabled]="formSubmitting || checkSubmitting">Cancel</button>
  </div>
  <div class="form-group text-danger text-center" *ngIf="(formSubmitted && !toBePaid.valid()) || (checkSubmitted && !check.valid())">Please correct errors above before proceeding</div>
</form>
